import { apiClient } from '../../../app/api/apiClient';
import type { MonitoringSnapshot } from '../types/monitoring.types';

export async function getMonitoringOverview(): Promise<MonitoringSnapshot> {
  const response = await apiClient.get('/api/super-admin/monitoring/overview');
  return (response.data as { monitoring: MonitoringSnapshot }).monitoring;
}
